var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Fill 1")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/search",
    transform: "translate(-3.000000, -3.000000)",
    fill: "#A6A7A9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9930817,4.83066054 C9.34716179,4.83066054 7.80137388,5.46978438 6.64125067,6.63068987 C4.24042928,9.03072899 4.24042928,12.9350951 6.64125067,15.3351342 C7.80137388,16.4960397 9.34716179,17.1351635 10.9930817,17.1351635 C12.6390016,17.1351635 14.1847895,16.4960397 15.3449127,15.3351342 C17.7449518,12.9350951 17.7449518,9.03072899 15.3449127,6.63068987 C14.1847895,5.46978438 12.6390016,4.83066054 10.9930817,4.83066054 M18.8119836,19.5 C18.6312766,19.5 18.4607393,19.4295947 18.3324451,19.3020828 L15.7743852,16.7432406 C14.4359018,17.8548624 12.7446096,18.4650418 10.9930817,18.4650418 C8.9904415,18.4650418 7.11140175,17.6882364 5.69938395,16.2762186 C4.28814844,14.8649831 3.5105608,12.9843788 3.5105608,10.9825209 C3.5105608,8.98144526 4.28814844,7.10084095 5.69938395,5.68960544 C7.11140175,4.27758764 8.9904415,3.5 10.9930817,3.5 C12.9949396,3.5 14.8747616,4.27758764 16.2867794,5.68960544 C19.0255464,8.42837237 19.2101648,12.8326162 16.7342444,15.7872928 L19.2907397,18.3437882 C19.4190339,18.4713001 19.4894392,18.6418374 19.4894392,18.8225444 C19.4894392,19.0032514 19.4190339,19.1737887 19.2907397,19.3020828 C19.1624456,19.4295947 18.9926906,19.5 18.8119836,19.5",
    id: "Fill-1"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_search.4b7599af.svg";
export { ForwardRef as ReactComponent };